/** @format */

import React from 'react'
import _ from 'lodash'
import { useGA4React } from 'ga-4-react'

import './style.css'

export function GameLogo(props) {
  const className = _([
    'game-logo',
    props.left && 'l',
    props.top && 't',
    props.right && 'r',
    props.bottom && 'b',
  ])
    .compact()
    .join(' ')

  const ga = useGA4React()

  const vuseLogo = () => {
    window.open('https://vuse.co.nz/')
    ga.event('vuse_logo_click', 'Flavour Drop')
  }

  return (
    <div className={className} onClick={() => vuseLogo()}>
      <svg
        width="65"
        height="77"
        viewBox="0 0 78 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M18.3379 56.8181L18.3206 56.8667C18.1174 57.4261 14.7193 66.8869 14.6084 67.1465C14.1174 68.289 13.4667 68.844 12.6182 68.844C11.7698 68.844 11.119 68.289 10.628 67.1465C10.5172 66.888 7.11904 57.4282 6.91589 56.8667L6.89851 56.8181H2.8833L2.91915 56.9165C5.51013 64.0373 6.82464 67.5836 7.18205 68.4155C7.90774 70.1032 8.76054 71.2662 9.79041 71.9727C10.6063 72.5331 11.5047 72.7938 12.6182 72.7938C13.7307 72.7938 14.6302 72.5331 15.446 71.9727C16.4759 71.2662 17.3287 70.1022 18.0544 68.4155C18.4118 67.5836 19.7274 64.0373 22.3173 56.9165L22.3531 56.8181H18.3379Z"
            fill={props.fill ? props.fill : 'white'}
          />
          <path
            d="M67.1017 56.5465C62.6541 56.5465 59.0354 60.187 59.0354 64.6626C59.0354 66.624 59.7231 68.5064 60.9713 69.9604C62.2163 71.4112 63.9664 72.3795 65.9012 72.6878C67.3211 72.9139 68.7073 72.7733 70.0197 72.2702C71.1234 71.8472 72.1402 71.1743 72.9605 70.3239L70.3293 68.2024C70.137 68.3831 69.0354 69.3416 67.194 69.373C67.0017 69.3762 66.7997 69.3611 66.5574 69.3254C65.6155 69.1696 64.7225 68.7055 64.0403 68.0196C63.5493 67.5252 63.0093 66.2367 62.9865 66.1826L62.9681 66.1382H74.9051C75.0126 65.5367 75.6351 61.2785 72.4021 58.4949C71.37 57.6067 69.6123 56.5465 67.1017 56.5465ZM71.3722 63.4563H62.905L62.9137 63.4185C62.9159 63.4055 63.2071 62.0737 64.0414 61.2342C64.9289 60.3406 66.0121 59.8689 67.1723 59.8689C67.3765 59.8689 67.5829 59.884 67.7872 59.9143C68.6845 60.0636 69.5308 60.5158 70.2337 61.2234C71.0756 62.0705 71.3624 63.4055 71.3646 63.4185L71.3722 63.4563Z"
            fill={props.fill ? props.fill : 'white'}
          />
          <path
            d="M53.4786 72.0972C56.2608 70.8887 56.3857 68.6039 56.4227 67.72C56.5335 65.1106 54.0577 64.0676 53.2353 63.742C51.9631 63.24 48.9898 62.6558 48.2043 62.3756C47.7958 62.2296 47.4645 62.0294 47.1842 61.8044C46.9908 61.6497 46.5172 60.7712 47.4265 60.24C47.7372 60.0583 48.3597 59.8051 49.6611 59.8051C52.2977 59.8051 53.7589 60.9811 54.3325 61.3944L56.4216 58.8975C55.3559 57.9725 54.276 57.3883 53.1592 57.0356C52.1304 56.711 51.0365 56.5455 49.9067 56.5455C48.5748 56.5455 45.8491 56.7575 44.1717 58.865C43.559 59.6342 42.3412 62.4037 44.7942 64.3814C46.2619 65.5649 48.376 66.0702 49.6014 66.3222C50.464 66.4997 51.9664 66.874 52.4531 67.3586C52.6226 67.5274 52.7432 67.7222 52.7127 67.9905C52.5759 69.2335 50.8453 69.4239 49.7698 69.4239C48.7996 69.4239 47.8882 69.2465 47.0321 68.9922C45.5764 68.5595 44.4259 67.4571 44.4259 67.4571L42.4835 69.98C42.4835 69.98 43.4482 71.1863 45.8035 72.1015C47.0169 72.5732 50.4922 73.3943 53.4786 72.0972Z"
            fill={props.fill ? props.fill : 'white'}
          />
          <path
            d="M36.112 56.843V64.9299C36.112 66.1307 35.7296 67.1303 34.9756 67.8995C34.2315 68.6601 33.2961 69.0496 32.1956 69.0571C31.0951 69.0496 30.1598 68.6601 29.4145 67.8995C28.6606 67.1303 28.2793 66.1307 28.2793 64.9299V56.843L24.4933 56.8322V64.7459C24.4933 67.218 25.1462 69.0539 26.5465 70.5252C27.9653 72.016 29.8556 72.7787 32.163 72.7939H32.2H32.2369C34.5389 72.7766 36.4248 72.0139 37.8426 70.5252C39.244 69.0539 39.8969 67.2169 39.8969 64.7459V56.8549L36.112 56.843Z"
            fill={props.fill ? props.fill : 'white'}
          />
          <path
            d="M38.9527 7.38586C27.5328 7.38586 18.2748 16.6054 18.2748 27.9779C18.2748 39.3504 27.5328 48.57 38.9527 48.57C50.3726 48.57 59.6306 39.3504 59.6306 27.9779C59.6306 16.6054 50.3737 7.38586 38.9527 7.38586ZM40.6572 38.3594C40.1901 38.8571 39.5448 39.1297 38.8397 39.1297C37.7425 39.1297 36.7365 38.4698 36.277 37.4485L27.7566 19.4886H33.4187L41.0624 35.5336C41.2058 35.8441 41.2895 36.1665 41.3112 36.4943C41.359 37.1997 41.1265 37.8618 40.6572 38.3594ZM49.07 23.4244L49.0657 23.4352C49.0602 23.4439 49.0559 23.4536 49.0515 23.4633L46.2802 29.0728C46.1629 29.3097 45.812 29.3097 45.6947 29.0728L42.9223 23.4601C42.9179 23.4525 42.9147 23.4449 42.9114 23.4374L42.9049 23.4255H42.906C42.6963 22.9862 42.579 22.4951 42.579 21.9779C42.579 20.1096 44.1086 18.5885 45.988 18.5885C47.8685 18.5885 49.3981 20.1096 49.3981 21.9779C49.397 22.494 49.2797 22.9841 49.07 23.4244Z"
            fill={props.fill ? props.fill : 'white'}
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="78"
              height="92"
              fill={props.fill ? props.fill : 'white'}
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default GameLogo
